export const hasSameElements = <T>(a?: T[], b?: T[]) => {
  const left = a || [];
  const right = b || [];
  return left.length === right.length && left.every((x) => right.some((y) => x === y));
};
